export const apiConfig = {
  appName: window.location.origin,
  baseWeb: window.location.origin,
  apiAdress() {
    return `${
      this.baseWeb.endsWith("/") ? this.baseWeb : `${this.baseWeb}/`
    }api/`;
  },
  loginEndpoint: "login",
  userInfo: "smartbook/sbookpublic/getuserInfo",
  registerEndpoint: "/jwt/register",
  refreshEndpoint: "/identity/Auth/refresh-token",
  revokeTokenEndPoint: "/identity/Auth/revoke-refresh-token",
  logoutEndpoint: "/jwt/logout",
  getUserInfo: "account/GetUserInfo",
  downloadBookPage: "smartbook/SbPublicGuess/GetImage",
  downloadBook: "smartbook/SbPublicGuess/GetSmartBook",
  getPublishers: "smartbook/SbPublicGuess/GetPublishers",
  getBooks: "smartbook/SbPublicGuess/GetBooks",
  getGroupBooks: "smartbook/SbPublicGuess/getgroupbooks",
  checkBookUpdates: "smartbook/SbPublicGuess/UpdateControl",
  manage: {
    savePageItem: "smartbook/sbmanage/savepageitem",
    savequestionsetting: "smartbook/sbmanage/savequestionsetting",
    saveQuestionFile: "smartbook/sbmanage/savequestionfile",
    deleteQuestionFile: "smartbook/sbmanage/deletequestionfile",
  },
};
export const logopath = "/library/logo.svg";
